import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button, Form, Spinner,
} from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import VerificationInput from 'react-verification-input';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../hooks/useAuth';
import useForm from '../hooks/useForm';

import './auth.css';

function VerifyForgotPassword() {
  const { getMemberNo } = useAuth();
  const memberNo = getMemberNo();
  const navigate = useNavigate();
  const title = 'Verify Forgot Password';
  const STYLE = {
    width: '150px',
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '14px',
  };

  const [isLoading, setIsLoading] = useState(false);
  const [catchError, setIsCatchError] = useState('');
  const [otpComplete, setIsOtpComplete] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const { verifyForgotPassword } = useAuth();

  const handleOtpChange = (vals) => {
    if (vals.length >= 1) {
      setIsOtpComplete(vals);
    } else if (vals.length === 0) {
      setIsOtpComplete(vals);
    }
  };

  const handleVerify = async () => {
    if (otpComplete.length < 4) {
      setIsCatchError('OTP should be min 4 digits');
      setIsError(true);
      return;
    }
    try {
      setIsLoading(true);
      await verifyForgotPassword(memberNo, otpComplete);
      setIsAlert(true);
      setIsLoading(false);
    } catch (err) {
      setIsCatchError(err.message);
      setIsError(true);
      setIsLoading(false);
    }
  };

  const onConfirm = () => {
    setIsAlert(false);
    setIsError(false);
  };

  const onVerified = () => {
    setIsAlert(false);
    navigate('/set-password');
  };

  const {
    handleSubmit,
  } = useForm({
    onSubmit: handleVerify,
  });

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <main className="container">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/login">Login</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>{title}</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="page-title">{title}</h1>
        <div className="container-auth">
          <Form className="row g-2" noValidate>
            <p>One Time Password (OTP)</p>
            <div style={ STYLE }>
              <VerificationInput
                removeDefaultStyles
                classNames={{
                  container: 'member-container',
                  character: 'character',
                  characterInactive: 'character--inactive',
                  characterSelected: 'character--selected',
                }}
                length={4}
                validChars={'0-9'}
                onChange={handleOtpChange}
              />
            </div>
            <Button className="w-100 btn btn-green mt-3"
                    type="button"
                    disabled={isLoading}
                    onClick={handleSubmit}
            >
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading}/>
              <span className="px-2">Verify Account</span>
            </Button>
            <p>
              <div className="row mb-3"/>
              <div className="mt-4">
                <span className="helper-text m-b-10">
                        Already have an Account? <i className="fa fa-lock"/>
                        <Link to="/login">Back to Login</Link></span><br/>
                <span className="helper-text m-b-10">
                    Forgot password? <i className="fa fa-lock"/>
                    <Link to="/forgot">Reset</Link></span><br/>
                <span className="helper-text m-b-10">
                        Don't have an account? <i className="fa fa-user-plus"/>
                        <Link to="/signup">Register</Link></span>
              </div>
            </p>
          </Form>
        </div>
      </main>
      {isAlert
      && <SweetAlert
        success
        title="Successfully verified!"
        onConfirm={onVerified}
      >
        Please proceed to login
      </SweetAlert>
      }
      {isError
      && <SweetAlert
        warning
        title= {catchError}
        onConfirm={onConfirm}
        timeout={10000}
      >
      </SweetAlert>}
    </>
  );
}

export default VerifyForgotPassword;
